import { RequestService } from '../../../common/services/RequestService';
import { GET_WEEK_DAYS } from '../constants';

export const getWeekDays = payload => {
  return RequestService.get(GET_WEEK_DAYS);
};
